import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

interface InviteBoardMemberDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (userIdOrEmail: string) => void;
}

export function InviteBoardMemberDialog({
  open,
  onClose,
  onSubmit,
}: InviteBoardMemberDialogProps) {
  const [value, setValue] = useState('');
  const canSubmit = value.trim().length > 0;

  useEffect(() => {
    if (!open) setValue('');
  }, [open]);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Invite member</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Email or username"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          inputProps={{ 'aria-label': 'email or username' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!canSubmit}
          onClick={() => {
            onSubmit(value.trim());
            setValue('');
          }}
        >
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
}
